import { cva } from 'class-variance-authority';

export const styles = cva(
  [
    'relative flex size-fit items-center justify-center rounded-lg font-semibold first-letter:capitalize',
    'text-nowrap motion-safe:transition-colors motion-safe:duration-300 *:motion-safe:transition-colors *:motion-safe:duration-300 motion-reduce:transition-none *:motion-reduce:transition-none',
    'focus:shadow-none focus:outline-none focus:ring-2 focus:ring-brand-600 focus:ring-offset-2',
    'disabled:cursor-not-allowed disabled:text-foreground-disabled [&>svg]:disabled:text-foreground-disabled-subtle',
  ],
  {
    variants: {
      intent: {
        primary: [
          'border-2 border-solid border-[var(--Gradient-skeuemorphic-gradient-border)] bg-brand-600 text-white-100 shadow-xs-skeumorphic',
          '[&>svg]:text-primary-icon',
          'not-disabled:hover:bg-brand-700 [&>svg]:hover:text-primary-icon-hover',
        ],
        secondary: [
          'border border-primary-border bg-white-100 text-secondary-700 shadow-xs-skeumorphic',
          '[&>svg]:text-quaternary-400',
          'hover:text-secondary-hover not-disabled:hover:bg-primary-hover [&>svg]:hover:text-quaternary-hover',
        ],
        tertiary: [
          'text-tertiary-600',
          '[&>svg]:text-quaternary-400',
          'hover:text-tertiary-hover not-disabled:hover:bg-primary-hover [&>svg]:hover:text-quaternary-hover',
        ],
        'link-color': ['!p-0 text-brand-700', '[&>svg]:text-brand-500', 'hover:text-brand-800 [&>svg]:hover:text-brand-600'],
        'link-grey': ['!p-0 text-tertiary-600', 'hover:text-tertiary-hover'],
      },
      size: {
        sm: 'gap-1 px-2.5 py-2 text-sm',
        md: 'gap-1 px-4 py-2.5 text-sm',
        lg: 'gap-1.5 px-[1.125rem] py-2.5 text-base',
        xl: 'gap-1.5 px-5 py-3 text-base',
      },
      isLoading: {
        false: [],
        true: '[&>svg]:hidden first:[&>svg]:block',
      },
    },
    compoundVariants: [
      {
        intent: 'primary',
        isLoading: true,
        class: 'bg-brand-700',
      },
      {
        intent: 'primary',
        isLoading: false,
        class: 'disabled:border-disabled-subtle disabled:bg-disabled-background disabled:shadow-xs [&>svg]:text-foreground-disabled-subtle',
      },
      {
        intent: 'secondary',
        isLoading: true,
        class: 'bg-primary-hover',
      },
      {
        intent: 'secondary',
        isLoading: false,
        class: 'disabled:border-disabled-subtle disabled:shadow-xs',
      },
      {
        intent: 'tertiary',
        isLoading: true,
        class: 'bg-primary-hover',
      },
    ],
    defaultVariants: {
      intent: 'primary',
      size: 'sm',
      isLoading: false,
    },
  }
);
